import { Button, OutlinedInput, Stack, Typography } from '@mui/material';

import type { StepProps } from '@/components/wizard/StepProps';
import { validateName } from '@/components/wizard/renameEntityName';

import type { StorageGatewayWizardState } from './storageGatewayWizardFlow';

export const GatewayNameSelection = (
  props: StepProps<StorageGatewayWizardState>
) => {
  const next = () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  return (
    <Stack sx={{ height: '100%' }} alignItems='center' justifyContent='center'>
      <div>
        <Typography variant='h3' sx={{ mb: '24px', textAlign: 'center' }}>
          How do you want to call your gateway policy?
        </Typography>
        <OutlinedInput
          inputProps={{ 'data-testid': 'create-gateway-policy-name-input' }}
          autoFocus
          sx={{
            width: '655px',
            padding: '8px',
          }}
          placeholder='Use a descriptive name, so you could identify it later'
          onChange={(e) =>
            props.setWizardState((state) => ({
              ...state,
              dlsgPolicy: { ...state.dlsgPolicy, name: e.target.value },
            }))
          }
          onKeyDown={(e) => {
            if (
              e.key === 'Enter' &&
              validateName(props.wizardState.dlsgPolicy.name)
            ) {
              next();
            }
          }}
          value={props.wizardState.dlsgPolicy.name}
          endAdornment={
            <Button
              data-testid='create-gateway-policy-name-continue-btn'
              sx={{ width: '200px' }}
              variant='contained'
              disabled={!validateName(props.wizardState.dlsgPolicy.name)}
              onClick={next}
            >
              Continue
              <i className='material-symbols-arrow-right-alt ml-[8px]' />
            </Button>
          }
        />
      </div>
    </Stack>
  );
};
